import { SCHOOLS_DAYCARE_SUBSUBSECTOR_ABBREVIATION, SCHOOLS_DAYCARE_SUBSUBSECTOR_ID } from "../bisko/constants";
import { RETROFIT_BUILDING_TYPE } from "./retrofit-building-type";
export const SCHOOL_DAYCARE_ENVELOPE_RETROFIT_PROFILE = {
    slug: "school-daycare-envelope-retrofit",
    subsubsectorId: SCHOOLS_DAYCARE_SUBSUBSECTOR_ID,
    subsubsectorAbbreviation: SCHOOLS_DAYCARE_SUBSUBSECTOR_ABBREVIATION,
    defaultFloorAreaSquareMetreByBuildingType: {
        [RETROFIT_BUILDING_TYPE.SCHOOL]: 1600,
        [RETROFIT_BUILDING_TYPE.DAYCARE]: 950,
    },
    usefulHeatOutputKwhPerSquareMetre: {
        UNRENOVATED_MEAN: 222.1,
        VERY_HIGH: 329.8,
        HIGH: 204.4,
        MEDIUM: 132.1,
        LOW: 69.8,
        VERY_LOW: 38.9,
    },
    canClaimWholeNodeConsumption: true,
};
